<script>
  import Button from '@components/Button.svelte';
  export let question;
  export let expanded = false;
  export let mobile = false;
  export let questionIndex;
  $: currentAnswer = question ? question.r : null;
  export let submitAnswer;
  const submitAnswerHandler = function (answer) {
    if (answer) {
      submitAnswer(question, answer);
    } else {
      currentAnswer = answer;
      submitAnswer(question, answer);
    }
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .option {
    margin-top: 18px;
    .add-another {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      .add-another-text {
        color: var(--purple-purple, #ae94f9);
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        &:hover {
          color: #896bd9;
        }
      }
    }

    &:first-child {
      margin-top: 0;
    }

    * :global(.btn-white) {
      /* will update if required */
      background: rgba(255, 255, 255, 0.64) !important;
      color: #1a1a1a !important;
    }

    * :global(.btn-white):enabled:hover {
      /* will update if required */
      background: #fff !important;
      color: #1a1a1a !important;
      box-shadow: 0px 16px 16px 0px rgba(80, 80, 80, 0.08);
    }

    &.added {
      :global(button.yes-button) {
        /* will update if required */
        background: #2caf87 !important;
        color: #fff !important;
      }
      :global(button.yes-button):enabled:hover {
        /* will update if required */
        background: #2caf87 !important;
        color: #fff !important;
      }
      :global(button.no-button) {
        /* will update if required */
        background: rgba(255, 255, 255, 0.3) !important;
        color: #b3b3b3;
      }
    }

    &.rejected {
      :global(button.no-button) {
        /* will update if required */
        background: rgba(214, 207, 234, 0.5) !important;
      }
    }
  }
  .mobile.collapsed {
    .title {
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .button-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
  }
  .title {
    font-weight: 500;
  }

  * :global(.bn-button) {
    border: 0 !important;
    height: 52px !important;
  }
</style>

{#if question}
  <div
    id="quiz-question-{questionIndex}"
    class:mobile={mobile}
    class="option {currentAnswer ? 'added' : currentAnswer == false ? 'rejected' : ''} {mobile
      ? 'mobile'
      : 'desktop'} {expanded ? 'expanded' : 'collapsed'}">
    <div class="title">{question.q}</div>
    <div class="button-wrapper">
      <Button
        class="yes-button"
        colorScheme="white"
        text="Yes"
        on:click={() => {
          submitAnswerHandler(true);
        }} />
      <Button
        class="no-button"
        colorScheme="white"
        disabled={currentAnswer == true || currentAnswer == false}
        text="No"
        on:click={() => {
          submitAnswerHandler(false);
        }} />
    </div>
    {#if currentAnswer == true}
      <div
        class="add-another"
        on:click={() => {
          submitAnswerHandler(true);
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M7.13924 1.13924C7.13924 0.510055 6.62918 0 6 0C5.37081 0 4.86076 0.510055 4.86076 1.13924V4.86076H1.13924C0.510055 4.86076 0 5.37081 0 6C0 6.62918 0.510055 7.13924 1.13924 7.13924H4.86076V10.8608C4.86076 11.4899 5.37081 12 6 12C6.62918 12 7.13924 11.4899 7.13924 10.8608V7.13924H10.8608C11.4899 7.13924 12 6.62918 12 6C12 5.37081 11.4899 4.86076 10.8608 4.86076H7.13924V1.13924Z"
            fill="#AE94F9" />
        </svg>
        <div class="add-another-text">Add another</div>
      </div>
    {/if}
  </div>
{/if}
